
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';


const openModal = createOpenModalAction('ResourceInfoModal');

export const startResourceInfoModal = (resourceId) => dispatch => {
    dispatch({
        type: actions.START_RESOURCE_INFO_MODAL,
        payload: { resourceId }
    })
    dispatch(openModal());
}